/**
 * App Component
 *
 * Root application component that wraps all routes.
 */

import { AppRoutes } from './routes'
import { OfflineIndicator } from './components/common'
import { useLanguageSync } from './hooks/useLanguageSync'

function App() {
  useLanguageSync()

  return (
    <>
      <OfflineIndicator />
      <AppRoutes />
    </>
  )
}

export default App
